module.exports = __webpack_public_path__ + "media/images/chip_delete_icon-b68c8da9.svg";